// Shared, pure resolver for role-based assessment "mark table" columns.
//
// The columns must be the sections SELECTED at creation (per-section question
// count > 0). The backend returns that list as assessmentInfo.roleBasedSections;
// this resolver prefers it and falls back to whatever role-based score keys the
// rows carry (excluding non-score keys like videoDetailedScores) so the table
// still works if the section list is missing.
//
// Returns an ordered list of { key, label } for the section columns (Overall is
// rendered separately by each table). Used by StudentsTable and CandidateList so
// both stay in sync. See roleBasedColumns.test.js.

// Canonical role-based score keys → default labels, in display order.
const ROLE_BASED_LABELS = {
  mcqScore: 'MCQ',
  subjectiveScore: 'Subjective',
  videoScore: 'Video',
  codingScore: 'Coding',
}

const ROLE_BASED_ORDER = Object.keys(ROLE_BASED_LABELS)

// roleBasedSections: [{ key, label, sectionName }] from the API (preferred).
// rows: student/candidate rows, each optionally carrying `roleBasedScores`.
function resolveRoleBasedSectionColumns(roleBasedSections, rows = []) {
  let defs = Array.isArray(roleBasedSections) ? roleBasedSections.filter(Boolean) : []

  if (defs.length === 0) {
    // Fallback: derive from the score keys present on the rows. Only the 4
    // canonical score keys count — this deliberately ignores metadata keys such
    // as videoDetailedScores / videoTotalQuestions / overallScore.
    const seen = new Set()
    ;(rows || []).forEach((r) => {
      Object.keys((r && r.roleBasedScores) || {}).forEach((k) => {
        if (ROLE_BASED_LABELS[k]) seen.add(k)
      })
    })
    defs = ROLE_BASED_ORDER.filter((k) => seen.has(k)).map((k) => ({ key: k, label: ROLE_BASED_LABELS[k] }))
  }

  return defs
    .filter((d) => d && d.key)
    .map((d) => ({ key: d.key, label: d.label || ROLE_BASED_LABELS[d.key] || d.key }))
}

module.exports = {
  ROLE_BASED_LABELS,
  ROLE_BASED_ORDER,
  resolveRoleBasedSectionColumns,
}
